import ExpandMore from '@/public/expand_more.svg';

type Props = {
  size?: number;
  className?: string;
};

export const ExpandMoreIcon = ({ size, className }: Props) => {
  return <img width={size} className={className} height={size} src={ExpandMore} alt="展開アイコン" />;
};
